import React from 'react'
import { Grid,Paper, List, ListItem, ListItemText, Typography, Divider, Button, Link } from '@material-ui/core';
import { Icon } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Prism from 'prismjs';
import CodeBase from './codeComponent';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';


export default class APIPage extends React.Component{
    constructor(props){
        super(props)
        window.addEventListener('resize',this.update)
        this.state={
            update:false,
            open:false,
        }
        
    }
    toggleDrawer=()=>{
        this.setState({open:(!this.state.open)})
    }
    update=()=>{this.setState({update:(!this.state.update)});}
    getListItem=()=>{
        return         ["Using in browser with script tag","Using with require",
        "Creating store","Adding actions",
        "Listening to actions","Removing Listener",
        "Executing listener for certain action",
        "Removing an action","Trigger an action",
        "Replacing an action callback","Reading Data from store"]
    }
    renderSideMenu=()=>{
        let list=null
        let listContent=null;
        if(window.screen.width<=768){
            if(this.state.open){
                 list=this.getListItem();
                 listContent=<List style={{color: 'black',position: 'sticky',top: '74px',left: '0'}}>
                                    {
                                        list.map((item,index)=>{
                                            return <ListItem key={index} button alignItems="flex-start">
                                                        <ListItemText  padding="56">{item}</ListItemText>
                                                    </ListItem>
                                            })
                                    }
                                <ListItem button alignItems="flex-start" onClick={this.toggleDrawer}>
                                    <ListItemText  padding="56">Close</ListItemText>
                                </ListItem>
                            </List>;
                return <div className="menuListContainer">
                    {listContent}
                </div>
            }else{
                return <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0
                }}>
                    <IconButton className="sideButtom" edge="start" color="inherit" aria-label="menu" onClick={this.toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                </div>
            }
        }
         list=this.getListItem();
         listContent=null;
        listContent=<List style={{color: 'black',position: 'sticky',top: '74px',left: '0'}}>
                            {
                                list.map((item,index)=>{
                                    return <ListItem key={index} button alignItems="flex-start">
                                                <ListItemText  padding="56">{item}</ListItemText>
                                            </ListItem>
                                    })
                            }
                    </List>
        return listContent;
    }

    getHTMLCode=(code,lang='html')=>{
        let html = Prism.highlight(code, Prism.languages[lang],lang);
        return <div  dangerouslySetInnerHTML={{__html: html}}></div> 
    }
    normalView=()=>{
        let list=this.renderSideMenu();
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        let consoleStyle=(window.screen.width<=768)?'consoleStyleMobile':'consoleStyle'
        return<Grid container justify='center'>
        <Grid item md={8} lg={8}>
            <Paper style={{margin:'20px',padding:'50px'}}>
            <Typography variant='h4' className='textTitle'>API reference</Typography>
                <Typography className={className}>
                    Actumjs  API has a very small number of functions to implement state management system.
                    Actumjs require you to write callback functions to perform actions that  modify app state,
                    and listeners to update ui components. 
                    This section provides complete reference to actumjs’s set of functions to manage app state.
                </Typography>
                <Typography variant='h4' className='textTitle'>Using  with script tag</Typography>
                <CodeBase
                    lines={[`\n<script src="https://actumjs.github.io/dist/v1.0.0/actum.js" type="text/javascript"></script>`]}
                    lang='html'
                />
                <Typography variant='h4' className='textTitle'>Using with import statement</Typography>
                <CodeBase
                    lines={[
                        "\nimport {createStore} from '@actumjs/actum';\n"
                    ]}
                    lang='js'
                />
                <Typography variant='h4' className='textTitle'>Creating store</Typography>
                <Typography className={className}>
                    You can create a store by calling  createStore function.
                    createStore,requires an object representing the initial state of the app as an argument.
                </Typography>
                <CodeBase
                    lines={[
                        "   //initial state of store\n",
                        "   const initial_state = { count:0 };         \n",
                        "   const store = createStore(initial_state);\n",
                    ]}
                    lang='js'
                    />  
                <Typography className={className}>
                    createStore returns a store object.
                    You can export the store further to use with other components.
                    <br/>
                    Store object comes with following methods
                </Typography>
                <ul className={className} style={{paddingLeft:'30px'}} >
                    <li >addAction</li>
                    <li >before</li>
                    <li >after</li>
                    <li >removeAction</li>
                    <li >replaceActionCallback</li>
                    {/* <li >executeListener</li> */}
                    <li >trigger</li>
                    <li >getState</li>
                </ul>
                <Typography variant='h4' className='textTitle'>
                Adding actions
                </Typography>
                <Typography className={className}>
                 The store object has the addAction method to add actions to the store.
                 addAction method requires an  action name ,and a callback function.
                </Typography>
                <Typography className={className}>
                    an action callback  function will be called with payload and current state.
                    the only way to modify state is to trigger an Action.
                    consider the following action to increase  counter value of the store.
                </Typography>
                <CodeBase
                        lines={[
                            `          \n`,
                            `store.addAction("increment",`,
                            `(payload,state)=>{ state.count++; });\n`,
                        ]}
                        lang='js'
                        />
                <Typography className={className+" devtip"}>
                    Note that ,an action callBack associated to an action can't trigger the same action from inside it.
                </Typography>
                <Typography variant='h4' className='textTitle'>
                    Listening to actions
                </Typography>
                <Typography className={className}>
                    In order to listen to  store updates,the component must add an action listener.
                    Actumjs allows to execute listener  before and after exeuction of action.
                    This can be done by using `after` and `before` methods of store object.
                    Each method as the name suggest ,is specify the sequence at which the listener callback is called.
                    <br/>
                     Both methods require action name and callback .
                     An actionName specify  action to which component want to listen updates.
                     This makes sense when you want to update components based on certain action.
                     The callback function when called will receive additional payload and proxy of current application state.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\n   //listening to increment action\n`,
                            `   const afterIncrement = store.after("increment",(payload,state)=>{\n`,
                            `        this.update();//your function to update component\n`,
                            `    })\n\n\n`,
                        ]}
                        lang='js'/>
                <Typography variant='h4' className='textTitle'>
                    Removing Listener
                </Typography>
                <Typography className={className}>
                    As shown in above example we listen to store updates by adding listeners to store.
                    When we add listener to action,using after or before
                    method, we receive a function.
                    <br/>
                    In above example we hold that function in variable 'afterIncrement'.
                    we can use it further to remove listener from action.
                    Its good practice to remove listeners when component no longer  need to  
                    react on actions or component is unmounted.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\t//removing listener \n`,
                            `\tafterIncrement();\n\n`,
                        ]}
                lang='js'/>
                {/* <Typography variant='h4' className='textTitle'>
                    Executing listener for certain action
                </Typography>
                <Typography className={className}>
                    While working with an async actions, such as making ajax call to an api,
                    you may want to execute a listener after finishing a certain task.
                    executeListener method is useful for such requirements.
                    in order to execute listeners of certain action you need call executeListener by passing action name,position and additional payload as arguments.
                    consider the following example.
                </Typography>
                <CodeBase
                        lines={[
                            `               \n`,
                            `     const {executeListener}=store;\n`,
                            `     //add an action to make ajax call\n`,
                            `     store.addAction({\n`,
                            `      name:"fetchData",\n`,
                            `      callback:(payload,val,prevent)=>{\n`,
                            `     //first you need to prevent,the after listener of an action\n`,
                            `        prevent();\n`,
                            `     //make an api call\n`,
                            `  fetch('https://example.com/fetchData').then((response)=> {\n`,
                            `    //on successful response\n`,
                            `    executeListener('after','fetchData',payload)\n`,
                            `  }).catch(function(e) {\n`,
                            `    console.log('request failed:',e);\n`,
                            `  });\n`,
                        ]}
                lang='js'/> */}
                <Typography variant='h4' className='textTitle'>
                Removing an action
                </Typography>
                <Typography className={className}>
                An action can be removed  by making a call to removeAction of store object.
                All listeners attached to action will automatically be removed.
                This method requires only name of action.
                </Typography>
                <CodeBase
                        lines={[
                            `\n`,
                            `const {removeAction} = store;\n`,
                            `//removing an action fetchdata\n`,
                            `removeAction('fetchData');\n\n`,
                        ]}
                        lang='js'
                        />
                <Typography variant='h4' className='textTitle'>
                Trigger an action
                </Typography>
                <Typography className={className}>
                    You can dispatch an action by calling trigger method of store object.
                    This will execute action callback as well as action listeners.
                    Trigger action requires action name to me executed.
                    You can pass additional data to action as payload.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\n    const {trigger} = store;\n`,
                            `    //triggering  an action increment           \n`,
                            `    trigger('increment',null);\n\n`,
                        ]}
                        lang='js'
                />
                <Typography variant='h4' className='textTitle'>
                    Replacing an action callback
                </Typography>
                <Typography className={className}>
                    replaceActionCallback is used to replace an existing callback  of an action.it requires action name and callback function.
                    In following example we will try to replace increment action callback with new one,which increase count value by 2.
                </Typography>
                <CodeBase
                        lines={[
                            `          \n`,
                            `     const {replaceActionCallback}=store;\n`,
                            `     replaceActionCallback("increment",(payload,state)=>{\n`,
                            `        state.count+ = 2;\n`,
                            `     });\n\n`,
                        ]}
                        lang='js'
                        />
                <Typography className={className}>
                    Now whenever increment action will be triggered ,it will increase  count value by two,instead of one.
                </Typography>
                <Typography variant='h4' className='textTitle'>
                Reading Data from store
                </Typography>
                <Typography className={className}>
                    Actumjs provides getState method of store object to get the state of app.
                    this method gives an proxy to  state of application store.
                </Typography>
                <CodeBase
                        lines={[
                            `          \n`,
                            `   const {getState} = store;\n`,
                            `   let state = getState();\n`,
                            `   console.log("count is  : ",state.count);\n`,
                            `            \n`,
                        ]}
                        lang='js'
                        />
                <Typography variant='h4' className='textTitle'>
                Directory structure
                </Typography>
                <Typography className={className}>
                    Actumjs impose almost no restriction on where your application store and actions are placed. 
                    however its good practice to have file organized in well defined structure.<br/>
                    Actumjs specify following directory structure
                    <br/>
                    <br/>&nbsp;&nbsp;|--src
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;|---store
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/index.js
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;|---actions
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/index.js
                    
                </Typography>
                    <Grid container justify='space-between'>
                        <Grid item >
                            <Link href="/get-started">
                                <ArrowLeft/>Get started
                            </Link>
                        </Grid>
                        <Grid item >
                            <Link href="/examples">
                                Examples
                            <ArrowRight/>
                            </Link>
                        </Grid>
                    </Grid>
            </Paper>
        </Grid>
    </Grid>
    }

    mobileView=()=>{
        let list=this.renderSideMenu();
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        let consoleStyle=(window.screen.width<=768)?'consoleStyleMobile':'consoleStyle'
       return <Grid container justify='center'>
        <Grid item md={12} lg={12}>
            <div style={{marginTop: '40px',paddingLeft: '10px',paddingRight: '10px'}}>
            <Typography variant='h4' className='textTitle'>API reference</Typography>
                <Typography className={className}>
                    Actumjs  API has a very small number of functions to implement state management system.
                    Actumjs require you to write callback functions to perform actions that  modify app state,
                    and listeners to update ui components. 
                    This section provides complete reference to actumjs’s set of functions to manage app state.
                </Typography>
                <Typography variant='h4' className='textTitle'>Using  with script tag</Typography>
                <CodeBase
                    lines={[`\n<script src="https://actumjs.github.io/dist/v1.0.0/actum.js" type="text/javascript"></script>`]}
                    lang='html'
                />
                <Typography variant='h4' className='textTitle'>Using with import statement</Typography>
                <CodeBase
                    lines={[
                        "\nimport {createStore} from '@actumjs/actum'\n"
                    ]}
                    lang='js'
                />
                <Typography variant='h4' className='textTitle'>Creating store</Typography>
                <Typography className={className}>
                    You can create a store by calling  createStore function.
                    createStore,requires an object representing the initial state of the app as an argument.
                </Typography>
                <CodeBase
                    lines={[
                        "   //initial state of store\n",
                        "   const initial_state = { count:0 };\n",
                        "   const store = createStore(initial_state)\n",
                    ]}
                    lang='js'
                    />  
                <Typography className={className}>
                    createStore returns a store object.
                    You can export the store further to use with other components.
                    <br/>
                    Store object comes with following methods
                </Typography>
                <ul className={className} style={{paddingLeft:'30px'}} >
                    <li >addAction</li>
                    <li >before</li>
                    <li >after</li>
                    <li >removeAction</li>
                    <li >replaceActionCallback</li>
                    {/* <li >executeListener</li> */}
                    <li >trigger</li>
                    <li >getState</li>
                </ul>
                <Typography variant='h4' className='textTitle'>
                Adding actions
                </Typography>
                <Typography className={className}>
                 The store object has the addAction method to add actions to the store.
                 addAction method requires an  action name ,and a callback function.
                </Typography>
                <Typography className={className}>
                    an action callback  function will be called with payload and current state.
                    the only way to modify state is to trigger an Action.
                    consider the following action to increase  counter value of the store.
                </Typography>
                <CodeBase
                        lines={[
                            `\nstore.addAction("increment",(payload,state)=>{ state.count++; })\n`,
                        ]}
                        lang='js'
                        />
                <Typography className={className+" devtip"}>
                    Note that ,an action callBack associated to an action can't trigger the same action from inside it.
                </Typography>
                <Typography variant='h4' className='textTitle'>
                    Listening to actions
                </Typography>
                <Typography className={className}>
                    In order to listen to  store updates,the component must add an action listener.
                    Actumjs allows to execute listener  before and after exeuction of action.
                    This can be done by using `after` and `before` methods of store object.
                    Each method as the name suggest ,is specify the sequence at which the listener callback is called.
                    <br/>
                     Both methods require action name and callback .
                     An actionName specify  action to which component want to listen updates.
                     This makes sense when you want to update components based on certain action.
                     The callback function when called will receive additional payload and the current application state.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\n       //listening to increment action\n`,
                            `       const afterIncrement = store.after("increment",(payload,state)=>{\n`,
                            `       //your function to update component\n        this.update();\n`,
                            `       })\n\n\n`,
                        ]}
                        lang='js'/>
                <Typography variant='h4' className='textTitle'>
                    Removing Listener
                </Typography>
                <Typography className={className}>
                    As shown in above example we listen to store updates by adding listeners to store.
                    When we add listener to action,using after or before
                    method, we receive a function.
                    <br/>
                    In above example we hold that function in variable 'afterIncrement'.
                    we can use it further to remove listener from action.
                    Its good practice to remove listeners when component no longer  need to  
                    react on actions or component is unmounted.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\t//removing listener \n`,
                            `\tafterIncrement();\n\n`,
                        ]}
                lang='js'/>
                {/* <Typography variant='h4' className='textTitle'>
                    Executing listener for certain action
                </Typography>
                <Typography className={className}>
                    While working with an async actions, such as making ajax call to an api,
                    you may want to execute a listener after finishing a certain task.
                    executeListener method is useful for such requirements.
                    in order to execute listeners of certain action you need call executeListener by passing action name,position and additional payload as arguments.
                    consider the following example.
                </Typography>
                <CodeBase
                        lines={[
                            `               \n`,
                            `     const {executeListener}=store;\n`,
                            `     //add an action to make ajax call\n`,
                            `     store.addAction({\n`,
                            `      name:"fetchData",\n`,
                            `      callback:(payload,val,prevent)=>{\n`,
                            `     //first you need to prevent,the after listener of an action\n`,
                            `        prevent();\n`,
                            `     //make an api call\n`,
                            `         $.ajax({\n`,
                            `             url:'https://example.com/fetchData',\n`,
                            `             method:'get',\n`,
                            `             success:(response)=>{\n`,
                            `                //on successful response \n`,
                            `               //execut all after listner of an action\n`,
                            `               executeListener('after','fetchData',payload);\n`,
                            `             }\n`,
                            `         })\n`,
                            `        }\n`,
                            `     })\n`,
                        ]}
                lang='js'/> */}
                <Typography variant='h4' className='textTitle'>
                Removing an action
                </Typography>
                <Typography className={className}>
                An action can be removed  by making a call to removeAction of store object.
                All listeners attached to action will automatically be removed.
                This method requires only name of action.
                </Typography>
                <CodeBase
                        lines={[
                            `\n`,
                            `const  { removeAction } = store;\n`,
                            `//removing an action fetchdata\n`,
                            `removeAction('fetchData');\n\n`,
                        ]}
                        lang='js'
                        />
                <Typography variant='h4' className='textTitle'>
                Trigger an action
                </Typography>
                <Typography className={className}>
                    You can dispatch an action by calling trigger method of store object.
                    This will  execute action callback as well as action listeners.
                    Trigger action requires action name to me executed.
                    You can pass additional data to action as payload.
                </Typography>
                <CodeBase
                        lines={[
                            `\n\n    const {trigger} = store;\n`,
                            `    //triggering  an action increment           \n`,
                            `    trigger('increment',null);\n\n`,
                        ]}
                        lang='js'
                />
                <Typography variant='h4' className='textTitle'>
                    Replacing an action callback
                </Typography>
                <Typography className={className}>
                    replaceActionCallback is used to replace an existing callback  of an action.it requires action name and callback function.
                    In following example we will try to replace increment action callback with new one,which increase count value by 2.
                </Typography>
                <CodeBase
                        lines={[
                            `          \n`,
                            `     const {replaceActionCallback} = store;\n`,
                            `     replaceActionCallback("increment",(payload,state)=>{\n`,
                            `        state.count+=2;\n`,
                            `     });\n\n`,
                        ]}
                        lang='js'
                        />
                <Typography className={className}>
                    Now whenever increment action will be triggered ,it will increase  count value by two,instead of one.
                </Typography>
                <Typography variant='h4' className='textTitle'>
                Reading Data from store
                </Typography>
                <Typography className={className}>
                    Actumjs provides getState method of store object to get the state of app.
                    this method gives an proxy to  state of application store.
                </Typography>
                <CodeBase
                        lines={[
                            `          \n`,
                            `   const {getState} = store;\n`,
                            `   let state =getState()\n`,
                            `   console.log("count is  : ",state.count);\n`,
                            `            \n`,
                        ]}
                        lang='js'
                        />
                <Typography variant='h4' className='textTitle'>
                Directory structure
                </Typography>
                <Typography className={className}>
                    Actumjs impose almost no restriction on where your application store and actions are placed. 
                    however its good practice to have file organized in well defined structure.<br/>
                    Actumjs specify following directory structure
                    <br/>
                    <br/>&nbsp;&nbsp;|--src
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;|---store
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/index.js
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;|---actions
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/index.js
                    
                </Typography>
                    <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                        <Grid item >
                            <Link href="/get-started">
                                <ArrowLeft/>Get started
                            </Link>
                        </Grid>
                        <Grid item >
                            <Link href="/examples">
                                Examples
                            <ArrowRight/>
                            </Link>
                        </Grid>
                    </Grid>
            </div>
        </Grid>
    </Grid>
    
        
    }

    render(){
        let content=null;
        let marginTop=0;
        if(window.screen.width<=768){
            content=this.mobileView();
            marginTop='36px';
        }else{
            content=this.normalView();
            marginTop='70px';
        }

            // const code = `var data = 1;`;
            // const html = Prism.highlight(code, Prism.languages.javascript, 'javascript');
            // <div dangerouslySetInnerHTML={{__html:html}}>
            // </div>


        return <div style={{marginTop:marginTop,color:'white',marginBottom:"20px"}}>
            {content}
        </div>; 
    }

}